import React, { useEffect, useState } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import useObservedDataControlPanel from 'utils/hooks/meteorology/useObservedDataControlPanel';
import ModeSwitch from '../ModeSwitch';
import PeriodSection from './PeriodSection';

import './index.scss';

type SheetSection = 'variavel' | 'visualizacao' | 'area' | 'periodo' | '';

export default function ControlPanelSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  const [openSection, setOpenSection] = useState<SheetSection>('variavel');
  const {
    variable,
    availableVariables,
    setSelectedVariable,
    region,
    regionOptions,
    setRegion,
    viewMode,
    setViewMode,
    isHeatmap,
    isHeatmapDisabled,
    variableLabel,
    viewModeLabel,
    plotAreaLabel,
    periodLabel,
    areParamsSelected,
    queryTrigger,
  } = useObservedDataControlPanel();

  useEffect(() => {
    if (open) setOpenSection('variavel');
  }, [open]);

  const toggleSection = (section: SheetSection) => () => (
    setOpenSection((current) => (current === section ? '' : section))
  );

  const confirm = () => {
    queryTrigger();
    dismiss();
  };

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Painel de controle"
      className="observed-data-control-panel-sheet"
    >
      <div className="observed-data-control-panel-sheet-body">
        <Section
          label="Variável"
          valueText={variableLabel}
          open={openSection === 'variavel'}
          onToggle={toggleSection('variavel')}
        >
          {availableVariables.map((v) => (
            <OptionRow
              key={v.id}
              label={v.label}
              selected={v.id === variable}
              onSelect={() => setSelectedVariable(v.id as any)}
            />
          ))}
        </Section>

        <Section
          label="Visualização"
          valueText={viewModeLabel}
          open={openSection === 'visualizacao'}
          onToggle={toggleSection('visualizacao')}
        >
          <ModeSwitch
            value={viewMode}
            onChange={setViewMode}
            heatmapDisabled={isHeatmapDisabled}
          />
        </Section>

        {!isHeatmap && (
          <Section
            label="Área de plotagem"
            valueText={plotAreaLabel}
            open={openSection === 'area'}
            onToggle={toggleSection('area')}
          >
            {regionOptions.map((r) => (
              <OptionRow
                key={r.id}
                label={r.label}
                selected={r.id === region}
                onSelect={() => setRegion(r.id)}
              />
            ))}
          </Section>
        )}

        <Section
          label="Período de seleção"
          valueText={periodLabel}
          open={openSection === 'periodo'}
          onToggle={toggleSection('periodo')}
        >
          <PeriodSection />
        </Section>
      </div>

      <div className="observed-data-control-panel-sheet-footer">
        <SheetActionButton
          variant="confirm"
          disabled={!areParamsSelected}
          onClick={confirm}
        >
          Realizar consulta
        </SheetActionButton>
      </div>
    </BottomSheet>
  );
}
